__turbopack_context__.v({
  "review-layout-desk": "LVGrQq_review-layout-desk",
});
